import { render } from "./GoldAZSupload.vue?vue&type=template&id=5aa9c346&scoped=true"
import script from "./GoldAZSupload.vue?vue&type=script&lang=js"
export * from "./GoldAZSupload.vue?vue&type=script&lang=js"

import "./GoldAZSupload.vue?vue&type=style&index=0&id=5aa9c346&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa9c346"]])

export default __exports__